import { baseApi } from "../baseApi";

export const statusApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    changeStatus: builder.mutation({
      query: ({ url, id }) => ({
        url: `${url}/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["State", "SubCategory", "Category","City","Product","Amenities","Location","Blog","FAQ"],
    }),

  }),
});

export const { useChangeStatusMutation } = statusApi;